import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaded
    ? _c(
        VSheet,
        [
          _c(
            VBreadcrumbs,
            [
              _c(
                VBreadcrumbsItem,
                { attrs: { exact: true, to: { name: "home", params: {} } } },
                [_vm._v("Home")]
              ),
              _c(VBreadcrumbsDivider, [_vm._v("/")]),
              _c(
                VBreadcrumbsItem,
                {
                  attrs: {
                    exact: true,
                    to: { name: "dynamicQrCode", params: {} },
                  },
                },
                [_vm._v(" Dynamic Qr Code ")]
              ),
              _c(VBreadcrumbsDivider, [_vm._v("/")]),
              _c(
                VBreadcrumbsItem,
                { attrs: { to: { name: "worksheetQRCode", params: {} } } },
                [_vm._v(" Worksheet ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-print-none" },
            [
              _c("div", { staticClass: "text-h6 text-center" }, [
                _vm._v("Entry Point: " + _vm._s(_vm.domainUrl)),
              ]),
              _c(
                VForm,
                { ref: "form" },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(VSelect, {
                        staticClass: "mx-2",
                        attrs: {
                          items: _vm.worksheetTypeDefinitions,
                          label: "Worksheet Type",
                          "item-text": "worksheetType",
                          "item-value": "id",
                          multiple: false,
                          rules: _vm.rules.select,
                          clearable: "",
                        },
                        model: {
                          value: _vm.worksheetTypeId,
                          callback: function ($$v) {
                            _vm.worksheetTypeId = $$v
                          },
                          expression: "worksheetTypeId",
                        },
                      }),
                      _vm.worksheetTypeId
                        ? _c(
                            VBtn,
                            {
                              staticClass: "my-auto",
                              attrs: {
                                to: {
                                  name: "worksheetTypeDefinitionView",
                                  params: { id: _vm.worksheetTypeId },
                                },
                                icon: "",
                              },
                            },
                            [
                              _c(VIcon, [
                                _vm._v("mdi-eye-arrow-right-outline"),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        VBtn,
                        {
                          staticClass: "my-auto",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.editWorksheetType()
                            },
                          },
                        },
                        [_c(VIcon, [_vm._v("mdi-tune")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.worksheetTypeFields &&
                  _vm.worksheetTypeFields.hasProcessType
                    ? _c(VSelect, {
                        staticClass: "mx-2",
                        attrs: {
                          items: _vm.processTypes,
                          label: "Process Type",
                          multiple: false,
                          "item-text": "name",
                          "item-value": "id",
                          chips: false,
                          "deletable-chips": "",
                          rules: _vm.rules.select,
                          clearable: "",
                        },
                        model: {
                          value: _vm.processTypeId,
                          callback: function ($$v) {
                            _vm.processTypeId = $$v
                          },
                          expression: "processTypeId",
                        },
                      })
                    : _vm._e(),
                  _vm.processTypeId
                    ? _c(
                        VRadioGroup,
                        {
                          staticClass: "mx-2",
                          attrs: { row: "", label: "For Process" },
                          model: {
                            value: _vm.processDirection,
                            callback: function ($$v) {
                              _vm.processDirection = $$v
                            },
                            expression: "processDirection",
                          },
                        },
                        [
                          _c(VRadio, {
                            attrs: { value: "Input", label: "Input" },
                          }),
                          _c(VRadio, {
                            attrs: { value: "Output", label: "Output" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.processTypeId && _vm.processDirection == "Input"
                    ? _c(
                        VRadioGroup,
                        {
                          staticClass: "mx-2",
                          attrs: { row: "", label: "Input Method" },
                          model: {
                            value: _vm.processInputMethod,
                            callback: function ($$v) {
                              _vm.processInputMethod = $$v
                            },
                            expression: "processInputMethod",
                          },
                        },
                        [
                          _c(VRadio, {
                            attrs: { value: "FIFO", label: "FIFO" },
                          }),
                          _c(VRadio, {
                            attrs: { value: "LIFO", label: "LIFO" },
                          }),
                          _c(VRadio, {
                            attrs: { value: "MANUAL", label: "Manual" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.processTypeId && _vm.processDirection == "Output"
                    ? _c(VTextField, {
                        staticClass: "mx-2",
                        attrs: {
                          label: "Output cost coefficient",
                          required: false,
                          type: "number",
                          hint: "Coefficient multiplier for output cost; a number between 0 and 1",
                        },
                        model: {
                          value: _vm.costCoefficient,
                          callback: function ($$v) {
                            _vm.costCoefficient = _vm._n($$v)
                          },
                          expression: "costCoefficient",
                        },
                      })
                    : _vm._e(),
                  _vm.processDirection != "Output"
                    ? _c(VSwitch, {
                        staticClass: "mx-2",
                        attrs: {
                          dense: "",
                          label: "Select from inventory only",
                        },
                        model: {
                          value: _vm.inventorySelectionOnly,
                          callback: function ($$v) {
                            _vm.inventorySelectionOnly = $$v
                          },
                          expression: "inventorySelectionOnly",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "mx-2 d-flex" },
                    [
                      _vm.worksheetTypeFields &&
                      _vm.worksheetTypeFields.hasLocation
                        ? _c(VSelect, {
                            attrs: {
                              disabled: _vm.userChooseLocation,
                              items: _vm.locations,
                              label: "Default Location",
                              multiple: false,
                              "item-text": "name",
                              "item-value": "id",
                              chips: false,
                              "deletable-chips": "",
                              clearable: "",
                            },
                            model: {
                              value: _vm.locationId,
                              callback: function ($$v) {
                                _vm.locationId = $$v
                              },
                              expression: "locationId",
                            },
                          })
                        : _vm._e(),
                      _c(VCheckbox, {
                        staticClass: "ml-4",
                        attrs: {
                          value: true,
                          label: "Let user choose location",
                        },
                        model: {
                          value: _vm.userChooseLocation,
                          callback: function ($$v) {
                            _vm.userChooseLocation = $$v
                          },
                          expression: "userChooseLocation",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.worksheetTypeFields &&
                  _vm.worksheetTypeFields.hasDocumentNumber
                    ? _c(VTextField, {
                        staticClass: "mx-2",
                        attrs: {
                          label: "Document Number Prefix",
                          required: false,
                        },
                        model: {
                          value: _vm.documentNumberPrefix,
                          callback: function ($$v) {
                            _vm.documentNumberPrefix = $$v
                          },
                          expression: "documentNumberPrefix",
                        },
                      })
                    : _vm._e(),
                  _vm.worksheetTypeFields &&
                  _vm.worksheetTypeFields.hasDeductibleWeight
                    ? _c(VTextField, {
                        staticClass: "mx-2",
                        attrs: {
                          label: "Deductible Weight",
                          required: false,
                          type: "number",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [_vm._v(" Kg ")]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3533068031
                        ),
                        model: {
                          value: _vm.deductibleWeight,
                          callback: function ($$v) {
                            _vm.deductibleWeight = _vm._n($$v)
                          },
                          expression: "deductibleWeight",
                        },
                      })
                    : _vm._e(),
                  _vm.worksheetTypeFields &&
                  _vm.worksheetTypeFields.hasTargetWeight
                    ? _c(VTextField, {
                        staticClass: "mx-2",
                        attrs: {
                          label: "Target Weight",
                          required: false,
                          type: "number",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "append",
                              fn: function () {
                                return [_vm._v(" Kg ")]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3533068031
                        ),
                        model: {
                          value: _vm.targetWeight,
                          callback: function ($$v) {
                            _vm.targetWeight = _vm._n($$v)
                          },
                          expression: "targetWeight",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    [
                      _vm.worksheetTypeFields &&
                      _vm.worksheetTypeFields.hasProduct
                        ? _c("product-select", {
                            staticClass: "mx-2 mb-6",
                            attrs: {
                              required: "",
                              "return-object": "",
                              multiple: _vm.multipleProducts,
                            },
                            model: {
                              value: _vm.products,
                              callback: function ($$v) {
                                _vm.products = $$v
                              },
                              expression: "products",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.worksheetTypeFields && _vm.worksheetTypeFields.hasMemo
                    ? _c(VTextarea, {
                        staticClass: "mx-2",
                        attrs: {
                          "hide-details": "",
                          label: "Memo",
                          outlined: "",
                        },
                        model: {
                          value: _vm.memo,
                          callback: function ($$v) {
                            _vm.memo = $$v
                          },
                          expression: "memo",
                        },
                      })
                    : _vm._e(),
                  _vm.worksheetTypeFields &&
                  _vm.worksheetTypeFields.hasEntryPhoto
                    ? _c(VSwitch, {
                        staticClass: "mx-2",
                        attrs: {
                          "hide-details": "",
                          dense: "",
                          label: `Require photo: ${
                            _vm.requirePhoto ? "Yes" : "No"
                          }`,
                        },
                        model: {
                          value: _vm.requirePhoto,
                          callback: function ($$v) {
                            _vm.requirePhoto = $$v
                          },
                          expression: "requirePhoto",
                        },
                      })
                    : _vm._e(),
                  _vm.worksheetTypeFields &&
                  _vm.worksheetTypeFields.hasSignature
                    ? _c(VSwitch, {
                        staticClass: "mx-2",
                        attrs: {
                          "hide-details": "",
                          dense: "",
                          label: `Require Signature: ${
                            _vm.requireSignature ? "Yes" : "No"
                          }`,
                        },
                        model: {
                          value: _vm.requireSignature,
                          callback: function ($$v) {
                            _vm.requireSignature = $$v
                          },
                          expression: "requireSignature",
                        },
                      })
                    : _vm._e(),
                  _vm.requireSignature
                    ? _c(
                        "div",
                        [
                          _vm._l(_vm.signatures, function (signature, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "d-flex justify-space-between",
                              },
                              [
                                _c("span", { staticClass: "my-auto" }, [
                                  _vm._v(_vm._s(index + 1) + "."),
                                ]),
                                _c(VTextField, {
                                  staticClass: "ma-2",
                                  attrs: {
                                    outlined: "",
                                    "hide-details": "",
                                    dense: "",
                                    label: "Signature Header",
                                  },
                                  model: {
                                    value: signature.signatureHeader,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        signature,
                                        "signatureHeader",
                                        $$v
                                      )
                                    },
                                    expression: "signature.signatureHeader",
                                  },
                                }),
                                _c(VTextField, {
                                  staticClass: "ma-2",
                                  attrs: {
                                    outlined: "",
                                    "hide-details": "",
                                    dense: "",
                                    label: "Signature Footer",
                                  },
                                  model: {
                                    value: signature.signatureFooter,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        signature,
                                        "signatureFooter",
                                        $$v
                                      )
                                    },
                                    expression: "signature.signatureFooter",
                                  },
                                }),
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "my-auto",
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteSignature(index)
                                      },
                                    },
                                  },
                                  [_c(VIcon, [_vm._v("mdi-delete")])],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _c(
                            "div",
                            { staticClass: "my-5 text-center" },
                            [
                              _c(
                                VBtn,
                                {
                                  attrs: { outlined: "" },
                                  on: { click: _vm.addSignature },
                                },
                                [
                                  _vm._v(" Add Signature "),
                                  _c(VIcon, { staticClass: "ml-2" }, [
                                    _vm._v("mdi-draw-pen"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(VSwitch, {
                    staticClass: "mx-2",
                    attrs: {
                      "hide-details": "",
                      dense: "",
                      label: "Require access code",
                    },
                    model: {
                      value: _vm.requireAccessCode,
                      callback: function ($$v) {
                        _vm.requireAccessCode = $$v
                      },
                      expression: "requireAccessCode",
                    },
                  }),
                  _vm.requireAccessCode
                    ? _c(VTextField, {
                        staticClass: "mx-2 my-2",
                        attrs: {
                          outlined: "",
                          "hide-details": "",
                          label: "Access Code",
                        },
                        model: {
                          value: _vm.accessCode,
                          callback: function ($$v) {
                            _vm.accessCode = $$v
                          },
                          expression: "accessCode",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "text-center my-6" },
                [
                  _c(
                    VBtn,
                    {
                      on: {
                        click: function ($event) {
                          return _vm.saveDynamicQrCode()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.qrCodeId ? "Update" : "Create") + " QR Code"
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }